import { render, staticRenderFns } from "./IntegratorTablesConfigTab.vue?vue&type=template&id=022a5def"
import script from "./IntegratorTablesConfigTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorTablesConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports